import React from 'react';
import { Chip } from '@mui/material';

const statusConfig = {
  approved: { label: 'Approved', color: '#10B981', bg: 'rgba(16, 185, 129, 0.15)' },
  rejected: { label: 'Rejected', color: '#EF4444', bg: 'rgba(239, 68, 68, 0.15)' },
  in_review: { label: 'In Review', color: '#F59E0B', bg: 'rgba(245, 158, 11, 0.15)' },
  open: { label: 'Open', color: '#10B981', bg: 'rgba(16, 185, 129, 0.15)' },
  closed: { label: 'Closed', color: '#F59E0B', bg: 'rgba(245, 158, 11, 0.15)' },
  takendown: { label: 'Taken Down', color: '#EF4444', bg: 'rgba(239, 68, 68, 0.15)' },
  delivered: { label: 'Delivered', color: '#10B981', bg: 'rgba(16, 185, 129, 0.15)' },
  pending: { label: 'Pending', color: '#F59E0B', bg: 'rgba(245, 158, 11, 0.15)' },
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.pending;
  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        color: config.color,
        backgroundColor: config.bg,
        border: `1px solid ${config.color}30`,
        fontWeight: 500,
        fontSize: '0.75rem',
      }}
    />
  );
}
